import { Button, Modal, Radio } from "ant-design-vue";
import { Action, ActionItem, fmtMsg } from "commonui";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ConversationNode, ConversationNodeType, Dialog, Path } from "../../conversation-builder.model";
import { ImageEditor } from "../../../../components/image-editor";
import IContentImageEditor from "@/components/content-image-editor/content-image-editor";
import { ContentExposureLocale, ConversationBuilderLocale } from "@/locales/localeid";
import ContentImageEditor from "@/components/content-image-editor/content-image-editor.vue";
import { getModule } from "vuex-module-decorators";
import { ConversationBuilderState } from "@/modules/conversation-builder";
import { ImageMetaData } from "@/models/image-meta-data";
import { BuilderPageType } from "@/util/enum";
@Component({
	components: {
		Modal,
		ImageEditor,
		Action,
		ActionItem,
		Button,
		RadioGroup: Radio.Group,
		Radio,
		ContentImageEditor
	}
})
export default class ConversationImageEditor extends Vue {
	@Prop() node?: ConversationNode<Dialog | Path>;
	@Prop() removeImage?: (closeEditor: () => void) => void;
	public editorKey = 0;

	conversationStore = getModule(ConversationBuilderState);

	get selectedPageImageId() {
		if (this.node) {
			return (this.node as ConversationNode<Dialog | Path>)?.data?.pageId;
		}
		return this.conversationStore.conversationProperties.pageId;
	}

	get selectedPageContentId() {
		if (this.node) {
			return (this.node as ConversationNode<Dialog | Path>)?.data?.contentId;
		}
		return this.conversationStore.conversationProperties.contentId;
	}

	$refs!: {
		imageEditor: IContentImageEditor;
	};

	public startEditing(pageMetaData?: ImageMetaData) {
		if (this.node?.data?.pageMetaData) {
			this.$refs.imageEditor.startEditing(this.node.data.pageMetaData as ImageMetaData);
		} else {
			this.$refs.imageEditor.startEditing(pageMetaData);
		}
	}

	get ImageSubmitText() {
		return fmtMsg(ContentExposureLocale.ContentExposureTeachingActivitiesImageSubmit);
	}

	get ImageCancelText() {
		return fmtMsg(ContentExposureLocale.ContentExposureTeachingActivitiesImageCancel);
	}

	public async uploadImage(item: {
		name: string;
		type: string;
		pageId: string;
		source: string;
		imageRelativeSource: string;
		contentId: string;
		metaData: ImageMetaData;
	}) {
		if (this.node) {
			// image of node being added/updated
			this.conversationStore.updateNodeData({
				id: this.node.id,
				data: {
					pageId: item.pageId,
					pageMetaData: item.metaData,
					imageUrl: item.imageRelativeSource,
					contentId: item.contentId
				}
			});
			this.conversationStore.uploadFile({
				imageInfo: {
					pageId: item.pageId,
					pageMetaData: item.metaData,
					type: this.node.type as ConversationNodeType,
					name: ""
				},
				type: this.$route.params.pagetype as BuilderPageType,
				node: this.node,
				id: this.node.id
			});
		} else {
			// image of conversation is being added/updated.
			// Currently this is not possible,
			// because the control for image upload from 'start-properties.vue' has been removed
			if (this.conversationStore.conversationProperties.id === null) {
				const type = this.$route.params.pagetype as BuilderPageType;
				const id = this.$route.params.id;
				await this.conversationStore.saveConversationState({ id, type });
			}
			this.conversationStore.setConversationProps({
				imageUrl: item.imageRelativeSource,
				pageId: item.pageId,
				pageMetaData: item.metaData,
				contentId: item.contentId
			});
			!this.conversationStore.changedSinceLastSave && this.conversationStore.setChangedSinceLastSave(true);
		}
		this.editorKey++;
	}
}
